export default __webpack_public_path__ + "img/e3c9cbb7e8a93835bdbbe2e83d16fa4a.png";